import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useProductContext } from "@/pages/import/DestinationsPage/ProductPage";

const ProductDetails = () => {
  const { product } = useProductContext();

  return (
    <>
      <div className="space-y-1">
        <h3 className="text-lg/6 font-medium text-gray-900">Details</h3>
      </div>
      <div className="mt-6">
        <DescriptionList>
          <DescriptionList.Item label="ID" value={product.id} />
          <DescriptionList.Item label="Name" value={product.name} />
          <DescriptionList.Item label="Description" value={product.description || "—"} />
          <DescriptionList.Item label="Destinations" value={product.destinations.join(", ") || "None"} />
          <DescriptionList.Item label="Created" value={<Timestamp timestamp={product.created_at} />} />
          <DescriptionList.Item label="Updated" value={<Timestamp timestamp={product.updated_at} />} />
        </DescriptionList>
      </div>
    </>
  );
};

export default ProductDetails;
